import PropTypes from 'prop-types'
import React from 'react'
import dateFormat from 'dateformat'

export default function ChartHintTimestamp (props) {
  const { timestamp } = props
  return <p><small>{dateFormat(timestamp, 'mm/dd/yy')}<br />{dateFormat(timestamp, 'hh:MM tt')}</small></p>
}

ChartHintTimestamp.propTypes = {
  timestamp: PropTypes.instanceOf(Date).isRequired
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/components/chart-hint-timestamp/index.js